import type { AdditionalFilterValues, AdditionalFilters } from "@bbj-types/candidate";
import { CandidateFieldFeatures } from "@bbj-types/organisation/enum";
import { StackGrid } from "@data-display/layout/StackGrid";
import { Divider, Typography } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { AdditionalField } from "./fields";
import { AdditionalFilterStack, classes } from "./styles";

export interface IFilterCandidateSchemasProps {
  value: AdditionalFilters;
  onChange: (field: string, value: AdditionalFilterValues | null) => void;
}

export const FilterCandidateSchemas = ({ value, onChange }: IFilterCandidateSchemasProps) => {
  const { candidateSchemas } = useGlobalContext();

  return (
    <>
      {candidateSchemas
        .filter((sectionSchema) =>
          sectionSchema.values.some(
            (fieldSchema) => fieldSchema.features & CandidateFieldFeatures.FILTERABLE && fieldSchema.isActive
          )
        )
        .map((sectionSchema) => (
          <AdditionalFilterStack key={sectionSchema.key} className={classes.root}>
            <Divider />
            <Typography variant="body1SemiBold" className={classes.sectionTitle}>
              {sectionSchema.title}
            </Typography>
            <StackGrid perLine={{ desktop: 2, xs: 1 }} rowGap={2} gap={2} strict>
              {sectionSchema.values
                .filter(
                  (fieldSchema) => fieldSchema.features & CandidateFieldFeatures.FILTERABLE && fieldSchema.isActive
                )
                .map((fieldSchema) => (
                  <AdditionalField
                    key={fieldSchema.value}
                    fieldSchema={fieldSchema}
                    value={value[fieldSchema.value] ?? null}
                    onChange={(value) => onChange(fieldSchema.value, value)}
                  />
                ))}
            </StackGrid>
          </AdditionalFilterStack>
        ))}
    </>
  );
};

export * from "./fields";
